import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Button } from '../Common/Button';
import { LoadingSpinner } from '../Common/LoadingSpinner';
import { showToast } from '../../hooks/useToast';

export function PendingUsers() {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.adminListUsers('pending').then(r => setUsers(r.users)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const approve = async (id: string) => {
    try { await api.adminApprove(id); showToast('success', 'User approved'); load(); }
    catch (err: any) { showToast('error', err.message ?? 'Failed'); }
  };
  const deny = async (id: string) => {
    if (!window.confirm('Deny this access request? They will not be able to sign in.')) return;
    try { await api.adminDeny(id); showToast('success', 'Request denied'); load(); }
    catch (err: any) { showToast('error', err.message ?? 'Failed'); }
  };

  if (loading) return <LoadingSpinner label="Loading…" />;
  if (users.length === 0) return <div className="text-sm text-text-muted">No pending requests.</div>;

  return (
    <div className="space-y-2">
      {users.map(u => (
        <div key={u.id} className="bg-surface border border-border rounded-lg px-4 py-3 flex items-center justify-between">
          <div className="min-w-0">
            <div className="text-sm font-medium text-text-primary truncate">{u.displayName}</div>
            <div className="text-xs text-text-muted truncate">{u.email}</div>
            <div className="text-[10px] uppercase tracking-wider text-text-hint mt-1">
              Requested {new Date(u.requestedAt).toLocaleString()}
            </div>
          </div>
          <div className="flex items-center gap-2 ml-3">
            <Button size="sm" variant="primary" onClick={() => approve(u.id)}>Approve</Button>
            <Button size="sm" variant="danger" onClick={() => deny(u.id)}>Deny</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
